import { render, staticRenderFns } from "./CardProofOrigin.vue?vue&type=template&id=d78cf756&scoped=true&"
import script from "./CardProofOrigin.vue?vue&type=script&lang=js&"
export * from "./CardProofOrigin.vue?vue&type=script&lang=js&"
import style0 from "./CardProofOrigin.vue?vue&type=style&index=0&id=d78cf756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78cf756",
  null
  
)

export default component.exports